module.exports = __webpack_public_path__ + "img/platform-external.bda77d8e.svg";